/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ first: NonNullable<unknown> }} Endpoint_Play_CallingInputs */

const en_endpoint_play_calling = /** @type {(inputs: Endpoint_Play_CallingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Example call: it goes to ${i?.first} first.`)
};

const zh_hans1_endpoint_play_calling = /** @type {(inputs: Endpoint_Play_CallingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`示例调用：先发给 ${i?.first}。`)
};

const pt_br2_endpoint_play_calling = /** @type {(inputs: Endpoint_Play_CallingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Chamada de exemplo: ela vai primeiro para ${i?.first}.`)
};

const es_endpoint_play_calling = /** @type {(inputs: Endpoint_Play_CallingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Llamada de ejemplo: primero va a ${i?.first}.`)
};

const fr_endpoint_play_calling = /** @type {(inputs: Endpoint_Play_CallingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Exemple d’appel : il va d’abord à ${i?.first}.`)
};

const de_endpoint_play_calling = /** @type {(inputs: Endpoint_Play_CallingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Beispielaufruf: Er geht zuerst an ${i?.first}.`)
};

const ru_endpoint_play_calling = /** @type {(inputs: Endpoint_Play_CallingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Пример вызова: сначала он уходит к ${i?.first}.`)
};

const it_endpoint_play_calling = /** @type {(inputs: Endpoint_Play_CallingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Chiamata di esempio: va prima a ${i?.first}.`)
};

/**
* | output |
* | --- |
* | "Example call: it goes to {first} first." |
*
* @param {Endpoint_Play_CallingInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const endpoint_play_calling = /** @type {((inputs: Endpoint_Play_CallingInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Endpoint_Play_CallingInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_endpoint_play_calling(inputs)
	if (locale === "pt-BR") return pt_br2_endpoint_play_calling(inputs)
	if (locale === "es") return es_endpoint_play_calling(inputs)
	if (locale === "fr") return fr_endpoint_play_calling(inputs)
	if (locale === "de") return de_endpoint_play_calling(inputs)
	if (locale === "ru") return ru_endpoint_play_calling(inputs)
	if (locale === "it") return it_endpoint_play_calling(inputs)
	return en_endpoint_play_calling(inputs)
});